// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__hLPZx","insightsList":"newBusinessInsightsMenu_insightsList__3yGIg","active":"newBusinessInsightsMenu_active__2DWoI"};